<template>
    <div class="pop" v-show="show"  @click.stop='_=>{}'>
        <div class="box">
            <div class="title">
                {{title}}
                <span @click="show = false" class="closeBtn"></span>
            </div>
            <div class="wrap">
                <div v-html='content' style='margin-bottom:10px;'></div>
                <template v-if="!noAgreement">
                    <button @click="exchange" class="arg_btn">{{argBtn}}</button>
                    <div class="argument" :class="{show: argBtn == '收起'}">
                        <div  style='padding: 5px 10px;' v-html='argument'></div>
                    </div>
                </template>
                <div class="selectItem" :class="{active: index == chooseIndex}" @click="choose(item,index)"
                    v-for="(item,index) in selectList" :key="index">
                    <i></i>
                    {{item.text}}
                </div>
                <div class="tips" v-show='tip'>请选择确认身份后再点击确认</div>
                <button class="roger" @click="close">确认</button>
            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'popselect',
        data: () => ({
            show: true,
            argBtn: '根据CME关于专业和非专业用户的规定',
            selectList: [],
            chooseIndex: -1,
            tip: false
        }),
        props: {
            list: {
                type: Array,
                default: () => ([])
            },
            title: {
                default: '确认购买人身份',
                type: String
            },
            content: {
                default: '请确认本人身份 <br>（针对专业用户和非专业用户数据授权费不同）',
                type: String
            },
            argument: {
                default: `
                    <p>CME charges different fees for Subscribers, depending on whether they qualify as Professional Subscribers or Non Professional Subscribers.</p>
                    <p style="margin-top: 12px;">
                        Non-Professional shall mean and include either (i) an individual, natural person Subscriber(s) who, or (ii) certain small business entities (limited liability companies, partnerships, trusts or corporations) that, receive and use Information (excluding any pit traded data), in each case subject to the following restrictions:
                    </p>
                    <h5 style='font-size: 14px;'>The Non-Professional Subscriber must: </h5>
                    <p>a) have an active futures trading account; and</p><p data-v-0b334658="">b) be an individual, natural person or a small business entity </p>
                    <h5>The Non-Professional Subscriber must not: </h5>
                    <p>c) be a member (or hold or lease any type membership) of any exchange;</p>
                    <p>d) be registered or qualified as a professional trader or investment adviser with any stock, commodities or futures exchange or contract market, or with any financial regulatory authority </p>
                    <p>e) be acting on behalf of an institution that engages in brokerage, banking, investment, or financial activities </p>
                    <h5>The Non-Professional Subscriber's Use of Information must: </h5>
                    <p>f) be solely for the Subscriber's personal or private use;</p>
                    <p>g) be limited to managing the Subscriber's own assets,and not be used in connection with the management of any assets of any third party(ies) in any capacity. </p>
                    <h5>The Non-Professional Subscriber's Access to Information must only: </h5>
                    <p>h) be via a maximum of two trading terminals per Distributor, permissioned for Real-Time Information and capable of routing orders to the CME Globex Platform (an“Order Routing Device”)</p>
                    <p style="margin-top: 12px;">Any Subscriber that does not meet the qualifications of a Non-Professional Subscriber will be considered a Professional Subscriber.</p>
                    <p>Notwithstanding anything herein, CME reserves the right in all cases to make a final determination as to whether a Subscriber is a Non-Professional or a Professional.</p>
                    `,
                type: String
            },
            argumentName: {
                default: '根据CME关于专业和非专业用户的规定',
                type: String
            },
            confirmCall: {
                default: () => {},
                type: Function
            },
            noAgreement: {
                default: false,
                type: Boolean
            }
        },
        methods: {
            close() {
                if (this.chooseIndex == -1) {
                    this.tip = true
                    return
                }
                this.show = false
                
                this.confirmCall && this.confirmCall(this.selectList[this.chooseIndex].val || this.chooseIndex)
            },
            exchange() {
                if (this.argBtn == this.argumentName) {
                    this.argBtn = '收起'
                } else {
                    this.argBtn = this.argumentName
                }

            },
            choose(item, index) {
                this.chooseIndex = index
                this.tip = false
            }
        },
        watch: {
            list: {
                handler(val) {
                    if (!val || val.length <= 0) return
                    this.selectList = val.map(v => ({
                        ...v,
                        _selected: false
                    }))
                },
                immediate: true
            },
            argumentName: {
                handler(val) {
                    this.argBtn = val
                },
                immediate: true
            }
        },
        components: {

        },
        mounted() {

        }
    }
</script>

<style scoped>
    .tips {
        color: #97253F;
        margin-top: 5px;
        margin-left: 20px;
    }
    .pop {
        position: fixed;
        z-index: 2000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .2);
    }

    .box {
        width: 494px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .title {
        height: 34px;
        background: url(../assets/image/confirm_title_bg.jpg) no-repeat;
        color: #fafafa;
        font-size: 15px;
        line-height: 34px;
        padding-left: 11px;
        position: relative;
    }

    .wrap {
        background: #fff;
        border: 1px solid #8b8b8b;
        border-top: 0;
        padding: 30px 60px;
        color: #7c7c7c;
        font-weight: bolder;
        font-size: 14px;
    }

    .roger {
        color: #fff;
        font-weight: bolder;
        background: rgb(73, 132, 212);
        padding: 5px 28px;
        cursor: pointer;
        display: block;
        width: 96px;
        zoom: 1;
        margin: 0 auto;
        border: 0;
        margin-top: 25px;
        outline: 0;
    }

    .arg_btn {
        background: transparent;
        border: 0;
        outline: 0;
    }

    .argument {
        color: #7c7c7c;
        max-height: 200px;
        height: 0;
        overflow: hidden;
        overflow-y: auto;
        background: #e0edfd;
        margin-bottom: 10px;
        transition: height .3s;
    }
    .argument >>> h5 {
        font-size: 14px;
        margin-bottom: 5px;
    }
    .argument >>> p {
        font-weight: normal;
    }
    .argument.show {
        height: 200px;
    }

    .arg_btn {
        color: #1261D2;
        text-decoration: underline;
        cursor: pointer;
        margin-bottom: 10px;
    }

    .selectItem {
        cursor: default;
    }

    .selectItem i {
        display: inline-block;
        width: 15px;
        height: 17px;
        vertical-align: middle;
        background: url(../assets/image/choose_01_y.png) no-repeat center;
    }

    .selectItem.active i {
        background: url(../assets/image/choose_01_y22.png) no-repeat center;
    }

    .closeBtn {
        width: 35px;
        height: 35px;
        position: absolute;
        right: 0;
        top: 0;
        background: url(../assets/image/close.png) no-repeat center;
        background-size: 12px;
        cursor: pointer;
    }
</style>